import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './locales/zh'
import en from './locales/en'
import { getDomainLocale } from './domains'

Vue.use(VueI18n)

// 检测浏览器语言
function detectBrowserLanguage() {
  const lang = navigator.language || navigator.browserLanguage
  if (lang && lang.toLowerCase().startsWith('zh')) {
    return 'zh'
  }
  return 'en'
}

// 语言优先级：localStorage > 域名默认 > 构建时语言 > 浏览器语言
// 手动选择按域名独立存储，刷新后保持，不做跨域名跳转
function getLocale() {
  // 手动切换过语言
  const savedLang = localStorage.getItem('locale')
  if (savedLang && ['zh', 'en'].includes(savedLang)) {
    return savedLang
  }
  // 按域名默认语言
  const domainLocale = getDomainLocale()
  if (domainLocale) {
    return domainLocale
  }
  // 本地开发按构建语言兜底
  const buildLocale = process.env.VUE_APP_SITE_LOCALE
  if (buildLocale && ['zh', 'en'].includes(buildLocale)) {
    return buildLocale
  }
  return detectBrowserLanguage()
}

const i18n = new VueI18n({
  locale: getLocale(),
  fallbackLocale: 'zh',
  messages: {
    zh,
    en
  }
})

export default i18n
